const STYLE = {
  maxWidth: 800,
  margin: "auto",
  marginBottom: 10,
};

export default STYLE;
